import PropTypes from 'prop-types'
import _ from 'lodash'
import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ValidationBox } from 'legacy/libs/react-form-tools'
import Select from 'legacy/libs/components/select'

import { GetText } from 'lib/gettext'

export default createReactClass({
  displayName: 'PollSelect',

  mixins: [SchemaBranchMixin],

  propTypes: {
    polls: PropTypes.arrayOf(PropTypes.object),
  },

  // The schema holds the 'poll' field that will be shared with other components
  schema: {
    poll: null,
  },

  /**
   * Sets an initial 'poll' value if none is found in the state.
   * Defaults to the first non-external poll if available;
   * otherwise falls back to the first external poll if found.
   */
  UNSAFE_componentWillMount() {
    if (!this.state.poll) {
      const firstStandardPoll = _.find(this.props.polls, (p) => !p.isExternal)
      if (firstStandardPoll) {
        this.cursors.poll.set(firstStandardPoll.pk)
      } else {
        const firstExternalPoll = _.find(this.props.polls, (p) => p.isExternal)
        if (firstExternalPoll) {
          this.cursors.poll.set(firstExternalPoll.pk)
        }
      }
    }
  },

  /**
   * Determines whether the currently selected poll is marked as external.
   * @returns {boolean} True if the poll is external, false otherwise.
   */
  isExternalPollSelected() {
    const selectedPollPk = this.state.poll
    const pollObject = _.find(this.props.polls, { pk: selectedPollPk })
    return pollObject ? pollObject.isExternal === true : false
  },

  /**
   * Returns an array of { label, value } objects for standard (non-external) polls.
   */
  getStandardPollOptions() {
    const standardPolls = _.filter(this.props.polls, (p) => !p.isExternal)
    return _.map(standardPolls, (poll) => ({
      label: poll.name,
      value: poll.pk,
    }))
  },

  /**
   * Helper method to return external polls sorted by dateModified (newest first).
   */
  getSortedExternalPolls() {
    const externalPolls = _.filter(this.props.polls, (p) => p.isExternal)
    return _.orderBy(
      externalPolls,
      [(poll) => new Date(poll.dateModified)],
      ['desc']
    )
  },

  /**
   * Returns an array of { label, value } objects for external polls sorted by date modified (most recent first).
   */
  getExternalPollOptions() {
    const sortedExternalPolls = this.getSortedExternalPolls()
    return _.map(sortedExternalPolls, (poll) => ({
      label: poll.name,
      value: poll.pk,
    }))
  },

  /**
   * Handles changes to the main dropdown. If "EXTERNAL" is chosen,
   * defaults the 'poll' value to the first external poll (if found).
   * Otherwise, sets 'poll' to the chosen standard poll pk.
   */
  handleMainSelectChange(newValue) {
    if (newValue === 'EXTERNAL') {
      const sortedExternalPolls = this.getSortedExternalPolls()
      if (sortedExternalPolls.length > 0) {
        this.cursors.poll.set(sortedExternalPolls[0].pk)
      }
    } else {
      this.cursors.poll.set(newValue)
    }
  },

  /**
   * Handles changes to the secondary dropdown for external polls.
   * Sets 'poll' to the chosen external poll pk.
   */
  handleExternalSelectChange(newValue) {
    this.cursors.poll.set(newValue)
  },

  /**
   * Helper method for Select components to render the selected value.
   */
  renderPollValue(item) {
    return <span>{item.label}</span>
  },

  /**
   * Helper method for Select components to render each option.
   */
  renderPollOption(item) {
    return this.renderPollValue(item)
  },

  /**
   * Renders the text/description for an external poll, if it exists.
   */
  renderExternalPollDescription() {
    const selectedPollPk = this.state.poll
    const pollObject = _.find(this.props.polls, { pk: selectedPollPk })
    if (pollObject && pollObject.description) {
      return (
        <p className="mt-2 text-xs text-default-light">
          {pollObject.description}
        </p>
      )
    }
    return null
  },

  /**
   * Renders the text/description for a standard poll, if it exists.
   */
  renderStandardPollDescription() {
    const selectedPollPk = this.state.poll
    const selectedPoll = _.find(this.props.polls, { pk: selectedPollPk })
    if (selectedPoll && selectedPoll.description) {
      return (
        <p className="mt-2 text-xs text-default-light">
          {selectedPoll.description}
        </p>
      )
    }
    return null
  },

  /**
   * Renders the component, including a main dropdown for standard polls vs. 'External',
   * and if 'External' is selected, a second dropdown for external poll selection.
   */
  render() {
    const standardOptions = this.getStandardPollOptions()
    const mainOptions = [
      ...standardOptions,
      { label: 'External', value: 'EXTERNAL' },
    ]

    // If the selected poll is external, the main dropdown shows 'EXTERNAL' as the selected value.
    const mainSelectValue = this.isExternalPollSelected()
      ? 'EXTERNAL'
      : this.state.poll

    return (
      <ValidationBox fieldPath="poll">
        <div className="my-8">
          <label className="mb-2 block text-default-light">
            <GetText>Poll</GetText>
          </label>

          <Select
            value={mainSelectValue}
            options={mainOptions}
            onChange={(value) => this.handleMainSelectChange(value)}
            renderValue={this.renderPollValue}
            renderOption={this.renderPollOption}
          />

          {this.isExternalPollSelected() ? (
            <>
              <p className="mt-2 text-xs text-default-light">
                External polls have been created by external research groups for
                their own projects and mounted on the DRH platform. You are
                welcome to create an external poll entry if you wish, but they
                are generally populated by invitation from the research group
                itself. We encourage most experts to answer one of the main DRH
                polls: Group, Place or Text.
              </p>

              <label className="mt-8 mb-2 block text-default-light">
                <GetText>External Poll</GetText>
              </label>

              <div>
                <Select
                  value={this.state.poll}
                  options={this.getExternalPollOptions()}
                  onChange={(value) => this.handleExternalSelectChange(value)}
                  renderValue={this.renderPollValue}
                  renderOption={this.renderPollOption}
                />
              </div>

              {this.renderExternalPollDescription()}
            </>
          ) : (
            this.renderStandardPollDescription()
          )}
        </div>
      </ValidationBox>
    )
  },
})
